import { Component } from '@angular/core';

@Component({
  selector: 'app-creator-dashboard',
  imports: [],
  templateUrl: './creator-dashboard.component.html',
  styleUrl: './creator-dashboard.component.css'
})
export class CreatorDashboardComponent {

}
